// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Request model for NewLeaf refill order validation.
*/
export class TcNewLeafRefillOrderValidationRequestModel {
    /**
    * @description DB spec:      RxNumber      INT      Mandatory
    */
    'rxNumber'?: number;
    /**
    * @description Db spec:      DateOfBirth      NVARCHAR(MAX)      Mandatory
    */
    'dobMmDdYyyy'?: string | null;
    /**
    * @description Db spec:      PhoneNumber      VARCHAR(80)      Optional
    */
    'phoneNumber'?: string | null;
    /**
    * @description Db spec:      IVRReference      NVARCHAR(MAX)      Optional
    */
    'ivrReference'?: string | null;
    /**
    * @description Db spec:      TFN/DD      VARCHAR(15)      Optional
    */
    'tfnDid'?: string | null;
    /**
    * @description Indicates if the Date of Birth is valid according to the expected format (MMddyyyy).
    */
    'dobMmDdYyyyIsValid'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TcNewLeafRefillOrderValidationRequestModel>> = [
        {
            "name":     "rxNumber",
            "baseName": "rxNumber",
            "type":     "number"
        },
        {
            "name":     "dobMmDdYyyy",
            "baseName": "dobMmDdYyyy",
            "type":     "string"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "ivrReference",
            "baseName": "ivrReference",
            "type":     "string"
        },
        {
            "name":     "tfnDid",
            "baseName": "tfnDid",
            "type":     "string"
        },
        {
            "name":     "dobMmDdYyyyIsValid",
            "baseName": "dobMmDdYyyyIsValid",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return TcNewLeafRefillOrderValidationRequestModel.attributeTypeMap;
    }
}
